"use client";

import { useRouter } from "next/navigation";
import { useMutation } from "@tanstack/react-query";
import { browserCmw } from "@/lib/ky/browser";
import { useOtpRetryStore } from "@/lib/otp-retry-store";
import { setSession } from "@/lib/session";
import type { SignUpDTO } from "cmw-client";

export function useSignUp(takeTurnstileToken: () => Promise<string>) {
  const router = useRouter();

  return useMutation({
    mutationFn: async (credentials: SignUpDTO) => {
      const auth = await browserCmw.auth.signUp(credentials, await takeTurnstileToken());

      await setSession(auth);

      return auth;
    },
    onSuccess: (auth) => {
      useOtpRetryStore.getState().setRetryAt(auth.otp?.retryAt ?? null);
      router.replace(`verify-email/?status=sent`);
    },
  });
}
